import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ContentBlockFacade } from '../facades/content-block.facade';

export function contentBlockCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        inject(ContentBlockFacade).clear();
        return true;
    };
}
